// extracted by mini-css-extract-plugin
module.exports = {"container":"home-articles_container__Ez_Ip","posts":"home-articles_posts__yKjvK","post":"home-articles_post__s2Won","image":"home-articles_image__oGXIT"};